import classnames from '@common/utils/ui/classnames';
import '@common/styles/components/skeleton.pcss';

export interface SkeletonProps {
  type?: 'short-line' | 'long-line' | 'image';
  color?: 'dark';
}

function Skeleton({ color, type = 'short-line' }: Readonly<SkeletonProps>) {
  return (
    <span
      className={classnames({
        skeleton: true,
        [`skeleton--type-${type}`]: !!type,
        [`skeleton--color-${color}`]: !!color,
      })}
    />
  );
}

export default Skeleton;
